import React, { useEffect, useState } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import payLogo from "../../images/flexipaybill_hor_white.svg";
import AppBar from "@material-ui/core/AppBar";
import bajsz from "./bajsz.svg";
import bill from "../../images/bill/bill_vigyor_80px.svg";
import billSad from "../../images/bill/6_bill_worried.svg";
import { makeExternalFormSubmit } from "../../FlexiComponents/FlexiForm";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { useMutator, useSurvey } from "../../hooks/useApi";
import StuckAfterOffer from "./stuckAfterOffer";
import { getFlexipayUrl } from "../../utils/urlHelpers";
import StuckAtDocUpload from "./stuckAtDocUpload";
import StuckAtSignature from "./stuckAtSignature";
import { useErrorOccurredNotification } from "../../hooks/useNotificationState";

const formId = "stuck-user-survey";
const submit = makeExternalFormSubmit(formId);

const StuckUserSurveyPage = ({ match }) => {
  const notifyError = useErrorOccurredNotification();
  const [surveySaved, setSurveySaved] = useState(false);
  const token = match?.params?.token;
  const [post, postLoading] = useMutator("POST", {
    headers: { Authorization: token }
  });
  const { data, isValidating: loading } = useSurvey(token);
  useEffect(() => {
    if (!loading && !data?.openedAt) {
      post(getFlexipayUrl("/guest/survey/open"));
    }
  }, [loading, data]);
  const saveSurvey = async surveyData => {
    if (surveyData?.quest2 === "1") {
      surveyData.quest2 = 1;
    }
    if (surveyData?.quest2 === "2") {
      surveyData.quest2 = 2;
    }
    if (surveyData?.quest2 === "3") {
      surveyData.quest2 = 3;
    }
    if (surveyData?.quest2 === "4") {
      surveyData.quest2 = 4;
    }
    if (surveyData?.quest2 === "5") {
      surveyData.quest2 = 5;
    }

    if (surveyData?.quest5 === "1") {
      surveyData.quest5 = 1;
    }
    if (surveyData?.quest5 === "2") {
      surveyData.quest5 = 2;
    }
    if (surveyData?.quest5 === "3") {
      surveyData.quest5 = 3;
    }
    if (surveyData?.quest5 === "4") {
      surveyData.quest5 = 4;
    }
    if (surveyData?.quest5 === "5") {
      surveyData.quest5 = 5;
    }
    if (data?.type === "DOCUMENT_UPLOAD") {
      if (surveyData?.quest1 === "e") {
        surveyData.quest1 = surveyData.freeText1;
      }
      if (surveyData?.quest3 === "b") {
        surveyData.quest3 = surveyData.freeText2;
      }
      if (surveyData?.quest4 === "e") {
        surveyData.quest4 = surveyData.freeText3;
      }
    }
    if (data?.type === "SIGNATURE") {
      if (surveyData?.quest1 === "d") {
        surveyData.quest1 = surveyData.freeText1;
      }
      if (surveyData?.quest3 === "c") {
        surveyData.quest3 = surveyData.freeText2;
      }
    }
    if (data?.type === "CALCULATION") {
      if (surveyData?.quest1 === "e") {
        surveyData.quest1 = surveyData.freeText1;
      }
      if (surveyData?.quest4 === "b") {
        surveyData.quest4 = surveyData.freeText2;
      }
    }
    if (
      surveyData?.quest1 ||
      surveyData?.quest2 ||
      surveyData?.quest3 ||
      surveyData?.quest4 ||
      surveyData?.quest5
    ) {
      await post(getFlexipayUrl("/guest/survey/save"), {
        ...surveyData,
        id: data.id
      });
      setSurveySaved(true);
    } else {
      notifyError({ text: "Hiba! Üres kérdőív." });
    }
  };
  return (
    <div
      style={{
        overflowX: "hidden",
        height: (!data?.type || surveySaved) && "100vh"
      }}
    >
      <AppBar position="relative" style={{ backgroundColor: "#000B55" }}>
        <Toolbar style={{ justifyContent: "space-between" }}>
          <img src={payLogo} alt="FlexiPay" width={132} />
        </Toolbar>
      </AppBar>
      {surveySaved === false && (
        <Grid container style={{ marginLeft: "80px", marginTop: "60px" }}>
          <Grid item xs={12}>
            {data?.type === "CALCULATION" && (
              <StuckAfterOffer formId={formId} onSubmit={saveSurvey} />
            )}
            {data?.type === "DOCUMENT_UPLOAD" && (
              <StuckAtDocUpload formId={formId} onSubmit={saveSurvey} />
            )}
            {data?.type === "SIGNATURE" && (
              <StuckAtSignature formId={formId} onSubmit={saveSurvey} />
            )}
          </Grid>
          {data?.type && (
            <Grid item xs={12}>
              <Button style={{ margin: "20px 0" }} onClick={submit}>
                Beküldöm
              </Button>
            </Grid>
          )}
        </Grid>
      )}
      {surveySaved === true && (
        <Grid container direction={"column"}>
          <Grid
            item
            xs={12}
            style={{
              justifySelf: "center",
              alignSelf: "center",
              marginTop: "60px"
            }}
          >
            <Typography variant={"h5"}>
              Sikeres küldés! Köszönjük, hogy időt szántál a visszajelzésre!
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              justifySelf: "center",
              alignSelf: "center",
              marginTop: "60px"
            }}
          >
            <img src={bill} alt={bill} style={{ width: "200px" }} />
          </Grid>
        </Grid>
      )}
      {data?.message && (
        <Grid container direction={"column"}>
          <Grid
            item
            xs={12}
            style={{
              justifySelf: "center",
              alignSelf: "center",
              marginTop: "60px"
            }}
          >
            <Typography variant={"h5"}>A munkamenet lejárt!</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              justifySelf: "center",
              alignSelf: "center",
              marginTop: "60px"
            }}
          >
            <img src={billSad} alt={billSad} style={{ width: "200px" }} />
          </Grid>
        </Grid>
      )}
      <Grid
        item
        style={{
          position: "fixed",
          bottom: 0,
          right: 0
        }}
      >
        <img src={bajsz} alt={bajsz} />
      </Grid>
    </div>
  );
};

export default StuckUserSurveyPage;
